<template>
  <!--PreLoader-->
  <div class="loader">
    <div class="loader-spinner"></div>
  </div>
  <!--PreLoader Ends-->
  <!-- header -->
  <LNavbarHome v-if="isHome" />
  <LNavbar v-else />
  <!-- header -->
  <router-view />

  <!-- footer -->
  <LFooter :list-data="listSocialMedia" />
  <!-- footer -->
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from "vue";
import { RouterView } from "vue-router";
import LNavbarHome from "@/components/layouts/Navbar.vue";
import LNavbar from "@/components/layouts/NavbarBasic.vue";
import LFooter from "@/components/layouts/Footer.vue";
import { useRoute } from "vue-router";
import { useCmsStores } from "@/store/cms";

export default defineComponent({
  name: "Master",
  components: {
    RouterView,
    LNavbarHome,
    LNavbar,
    LFooter,
  },
  setup() {
    const route = useRoute();
    const isHome = ref(false);

    onMounted(() => {
      isHome.value = route.path === "/";
      // console.log("isHome", isHome.value);
    });

    watch(
      () => route.path,
      (to, from) => {
        if (to === "/") {
          isHome.value = true;
        } else {
          isHome.value = false;
        }
      }
    );

    const cmsStore = useCmsStores();

    onMounted(async () => {
      await getSocialMedia();
    });

    const listSocialMedia = ref([]);
    const getSocialMedia = async () => {
      const params = {
        status: 1,
      };
      await cmsStore
        .getSocialMedia(params)
        .then((res) => {
          listSocialMedia.value = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    };

    return {
      isHome,
      cmsStore,
      listSocialMedia,
    };
  },
});
</script>